import classNames from "classnames";
import React from "react";
import {
  CategoryStandardProduct,
  StandardProductCategoryProduct,
} from "shared/api/middleware-api-client";
import Icon, { IconTypes } from "shared/ui/icon";
import { concatClassnames } from "shared/utils/concatClassnames";

interface ProductProps {
  categoryProduct: StandardProductCategoryProduct;
  isOptionActive: boolean;
  selectProduct: (product: CategoryStandardProduct) => void;
  index: number;
}

type ColorMapping = {
  [key: string]: string;
};
const colorMapping: ColorMapping = {
  verfsetral7021: "#303334",
  verfsetral7032: "#b5b1a3",
  verfsetral9010: "#f0ebe0",
  verfsetral7002: "#827965",
  verfsetral7040: "#989ea1",
  verfsetral9005: "#0f1011",
  verfsetgoud: "#c19d5d",
  verfsetmahonie: "#4c2b1f",
  verfsetbrons: "#79654d",
  verfsetleem: "#6d685f",
  verfsetral8019: "#3d3736",
  verfsetral5008: "#353f4b",
  verfsetgrijsbeige: "#A28D76",
  verfsettaupe: "#b0a290",
  verfsetparelwit: "#F1ECD6",
  verfsetdonkerbrons: "#1D120A",
};

export const StandardProductColor = ({
  categoryProduct,
  isOptionActive,
  selectProduct,
  index,
}: ProductProps) => {
  const bgColor = colorMapping[categoryProduct.standardProduct.code];

  return (
    <li
      key={index}
      className={classNames(
        "gg-relative gg-col-span-1 gg-w-fit gg-transition gg-duration-300 gg-ease-in-out hover:gg-scale-105",
        { "gg-col-span-6": index === 1 },
      )}
    >
      {isOptionActive && (
        <Icon
          name={IconTypes.WHITE_CHECK}
          className={`gg-absolute -gg-top-2.5 gg-left-full gg-aspect-square gg-w-5 -gg-translate-x-3 gg-rounded-full gg-bg-green-500 gg-p-1.5`}
        />
      )}

      <button
        className={concatClassnames(
          "gg-aspect-square gg-w-10 gg-cursor-pointer gg-rounded gg-border gg-border-dark-blue-500 sm:gg-w-14 lg:gg-w-10 xl:gg-w-14",
        )}
        onClick={() => selectProduct(categoryProduct.standardProduct)}
        style={{
          backgroundColor: bgColor,
        }}
      />
    </li>
  );
};
